export class DeleteSuccessEffect {
  public static readonly type = '[Project/Storage/List] DeleteSuccessEffect';
}
